import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import PlotSection from './components/PlotSection';
import CastSection from './components/CastSection';
import CategoryPreview from './components/CategoryPreview';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PlotSection />
        <CastSection />
        <CategoryPreview />
        <ArticlePreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '赤裸特工 - 官方正版落地页',
            description: '赤裸特工是一部融合动作、悬疑与间谍元素的热门作品，集结顶尖卡司与烧脑剧情。',
            url: 'https://www.chiluotegong.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '赤裸特工官方',
              url: 'https://www.chiluotegong.com/',
            },
            about: {
              '@type': 'TVSeries',
              name: '赤裸特工',
              genre: ['动作', '悬疑', '间谍'],
              description: '融合动作、悬疑与间谍元素的热门剧集',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '赤裸特工一共有几季？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '目前赤裸特工已播出一季（12集），第二季将于2026年9月15日正式首播，共12集，每集60分钟。制作方已确认第三季正在筹备中。',
                },
              },
              {
                '@type': 'Question',
                name: '赤裸特工在哪里可以观看？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '赤裸特工可在腾讯视频、爱奇艺、优酷和B站四大主流平台观看，均支持4K超高清画质。',
                },
              },
              {
                '@type': 'Question',
                name: '赤裸特工的主要演员有哪些？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '主演阵容包括张凯（饰演林）、陈晓（饰演苏婉）、刘洋（饰演幽灵）、王德顺（饰演陈长官）、赵小曼（饰演李娜）、黄志伟（饰演马克）等实力派演员。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}